import React from 'react';

import {CardTitle, FormGroup, Input} from 'reactstrap';
import renderExplanation from './Explanation';

const CustomSelectPlusInputTableTask = ({title, description, showCorrect, explanation}) => {

    return <>
        <CardTitle dangerouslySetInnerHTML={{ __html: title }} />
        <div>
            <table className='Task__table'>
                <tbody>
                <tr>
                    <th>Struktūra</th>
                    <th>Angliška kolokacija</th>
                    <th>Vertimas į lietuvių kalbą</th>
                </tr>
                <tr>
                    <td>bdv. + dkt.</td>
                    <td>
                        <FormGroup><Input type='select'>
                            <option>To call for help</option>
                            <option>To break (a/the) law</option>
                            <option>Data processing</option>
                            <option>High honour</option>
                            <option>Time runs out</option>
                        </Input></FormGroup>
                    </td>
                    <td><input className='TASK__input' /></td>
                </tr>
                <tr>
                    <td>dkt. + dkt.</td>
                    <td><FormGroup><Input type='select'>
                        <option>To call for help</option>
                        <option>To break (a/the) law</option>
                        <option>Data processing</option>
                        <option>High honour</option>
                        <option>Time runs out</option>
                    </Input></FormGroup></td>
                    <td><input className='TASK__input' /></td>
                </tr>
                <tr>
                    <td>vksm. + dkt.</td>
                    <td><FormGroup><Input type='select'>
                        <option>To call for help</option>
                        <option>To break (a/the) law</option>
                        <option>Data processing</option>
                        <option>High honour</option>
                        <option>Time runs out</option>
                    </Input></FormGroup></td>
                    <td><input className='TASK__input' /></td>
                </tr>
                <tr>
                    <td>vksm. + prl. + dkt.</td>
                    <td><FormGroup><Input type='select'>
                        <option>To call for help</option>
                        <option>To break (a/the) law</option>
                        <option>Data processing</option>
                        <option>High honour</option>
                        <option>Time runs out</option>
                    </Input></FormGroup></td>
                    <td><input className='TASK__input' /></td>
                </tr>
                <tr>
                    <td>dkt. + vksm. + prl.</td>
                    <td><FormGroup><Input type='select'>
                        <option>To call for help</option>
                        <option>To break (a/the) law</option>
                        <option>Data processing</option>
                        <option>High honour</option>
                        <option>Time runs out</option>
                    </Input></FormGroup></td>
                    <td><input className='TASK__input' /></td>
                </tr>
                </tbody>
            </table>

        </div>
        {(showCorrect && explanation)? renderExplanation(explanation) : undefined}
    </>
}

export default CustomSelectPlusInputTableTask;